import React from 'react';
import { Button } from '../ui/button';
import { MetricCard, DashboardPanel, AvatarCircle } from './DashboardUI';
import OvertimeRequestsManager from '../TimeManagement/OvertimeRequestsManager';

const LiveStatusTab = ({
  liveStatus,
  planInfo,
  hasRotaBuilder,
  currentLocation,
  sessionId,
  closeEmployeeSession,
  setShowSubscriptionManagement,
}) => (
  <div className="space-y-8" data-testid="live-status-tab">
    {/* Metrics Grid */}
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
      <MetricCard title="Checked In" value={liveStatus?.kpis?.employees_checked_in || 0} color="emerald" />
      <MetricCard title="On Break" value={liveStatus?.kpis?.employees_on_break || 0} color="amber" />
      <MetricCard title="Check-ins Today" value={liveStatus?.kpis?.total_checkins_today || 0} color="violet" />
      <MetricCard title="Open Sessions" value={liveStatus?.kpis?.open_sessions || 0} color="rose" />
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8">
      {/* Currently Checked In */}
      <DashboardPanel title="Currently Checked In" colSpan="lg:col-span-2">
        {liveStatus?.checked_in?.length > 0 ? (
          <div className="space-y-3">
            {liveStatus.checked_in.map((emp, idx) => (
              <div key={emp.id || idx} className="flex items-center justify-between bg-zinc-800/60 rounded-xl px-5 py-4">
                <div className="flex items-center gap-4">
                  <AvatarCircle
                    initials={emp.name?.split(' ').map(n => n[0]).join('') || '??'}
                    className="h-9 w-9 bg-emerald-500/20 text-emerald-300"
                  />
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="text-sm font-medium text-white">{emp.name}</p>
                      {emp.is_late && (hasRotaBuilder) && (
                        <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-rose-500/20 text-rose-300">Late</span>
                      )}
                    </div>
                    <p className="text-xs text-zinc-400">Since {emp.time}</p>
                  </div>
                </div>
                <Button size="sm" onClick={() => closeEmployeeSession(emp.id)} className="bg-zinc-700 hover:bg-zinc-600 text-zinc-200 rounded-lg">Close</Button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-zinc-400 text-center py-8">No employees currently checked in</p>
        )}
      </DashboardPanel>

      {/* Pending Overtime Requests */}
      <DashboardPanel title="Pending Requests">
        {currentLocation && (hasRotaBuilder) ? (
          <OvertimeRequestsManager locationId={currentLocation.id} sessionId={sessionId} />
        ) : (
          <div className="text-center py-6">
            <p className="text-sm text-zinc-400 mb-4">Overtime request management available on Growth plan and above</p>
            <Button onClick={() => setShowSubscriptionManagement(true)} className="bg-violet-500/20 text-violet-200 hover:bg-violet-500/30 rounded-xl">Upgrade Plan</Button>
          </div>
        )}
      </DashboardPanel>
    </div>

    {/* On Break */}
    {liveStatus?.on_break?.length > 0 && (
      <DashboardPanel title="On Break">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {liveStatus.on_break.map((emp, idx) => (
            <div key={emp.id || idx} className="flex items-center gap-3 bg-amber-500/5 border border-amber-500/10 rounded-xl px-4 py-3">
              <AvatarCircle initials={emp.name?.split(' ').map(n => n[0]).join('') || '??'} className="h-8 w-8 bg-amber-500/20 text-amber-300" />
              <div>
                <p className="text-sm font-medium text-white">{emp.name}</p>
                <p className="text-xs text-amber-400/70">Break since {emp.time}</p>
              </div>
            </div>
          ))}
        </div>
      </DashboardPanel>
    )}

    {/* Recently Checked Out */}
    <DashboardPanel title="Recently Checked Out">
      {liveStatus?.checked_out?.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {liveStatus.checked_out.map((emp, idx) => (
            <div key={emp.id || idx} className="bg-zinc-800/40 rounded-xl px-4 py-3">
              <p className="text-sm font-medium text-white">{emp.name}</p>
              <p className="text-xs text-zinc-400">Out at {emp.time}</p>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-zinc-400 text-center py-4">No recent check-outs</p>
      )}
    </DashboardPanel>
  </div>
);

export default LiveStatusTab;
